/*    
<summary>
   This file is used to provide initial values or state to the User Module observables.
   Developer:Sahil Bharti, Created Date:06-January-2025
</summary>
*/

import { ICategoryManagementListVM } from "../../models/response/ICategoryManagementResposne";



export const initialState: ICategoryManagementListVM = {
    CategoryVM: []
}